// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-narative-gatsby-theme-novela-templates-article-template-tsx": () => import("./../../../src/@narative/gatsby-theme-novela/templates/article.template.tsx" /* webpackChunkName: "component---src-narative-gatsby-theme-novela-templates-article-template-tsx" */),
  "component---src-narative-gatsby-theme-novela-templates-articles-template-tsx": () => import("./../../../src/@narative/gatsby-theme-novela/templates/articles.template.tsx" /* webpackChunkName: "component---src-narative-gatsby-theme-novela-templates-articles-template-tsx" */)
}

